var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReaction = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 26 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.988.5C6.088.5.5 6.1.5 13s5.588 12.5 12.488 12.5C19.9 25.5 25.5 19.9 25.5 13S19.9.5 12.988.5ZM13 23C7.475 23 3 18.525 3 13S7.475 3 13 3s10 4.475 10 10-4.475 10-10 10Zm4.375-11.25a1.872 1.872 0 0 0 1.875-1.875A1.872 1.872 0 0 0 17.375 8 1.872 1.872 0 0 0 15.5 9.875c0 1.037.837 1.875 1.875 1.875Zm-8.75 0A1.872 1.872 0 0 0 10.5 9.875 1.872 1.872 0 0 0 8.625 8 1.872 1.872 0 0 0 6.75 9.875c0 1.037.838 1.875 1.875 1.875ZM13 19.875c2.912 0 5.387-1.825 6.387-4.375H6.614c1 2.55 3.474 4.375 6.387 4.375Z"
  })));
};
export { SvgReaction as ReactComponent };